(function(){
    'use strict'

    angular
    .module('app.perfilesAsiento')
    .controller('PerfilesAsiento', PerfilesAsiento);

    PerfilesAsiento.$inject = ['$animationsSrv', 'PerfilesAsientoService', 'logger', '$location', 'UserInfoService'];

    function PerfilesAsiento($animationsSrv, PerfilesAsientoService, logger, $location, UserInfoService) {
    
        $animationsSrv.scrollToTop();
        
        var vm = this;

        vm.perfilesAsiento = [];
        vm.title = 'PerfilesAsiento';

        vm.goToEdit = function(perfilAsiento){
            
            var path = '/editar-perfil-asiento/';

            if(perfilAsiento){
                $location.path(path + perfilAsiento.id);
            }
            else{
                $location.path(path);
            }
            
        };

        vm.openModal = function(modalName){
            $(modalName).modal('toggle');    
        };

        getAll();

        function getAll(){

            var promise = PerfilesAsientoService.getAllPerfil();

            promise
            .then(function(perfilesAsiento){
                vm.perfilesAsiento = perfilesAsiento;
            })
            .catch(function(error){
                switch (error.status) {
                    case 401:
                        logger.error('La sessión ha terminado.');
                        break;
                
                    default:
                        logger.error('Error al obtener los Perfiles de Asiento.');
                        break;
                }
            });
        };

        vm.delete = function(perfilAsiento){
            var promise = PerfilesAsientoService.removePerfil(perfilAsiento);
            
            promise
            .then(function(response){
                vm.perfilesAsiento = vm.perfilesAsiento.filter(function(g) {
                    return g.id !== perfilAsiento.id;
                });
                logger.success('Perfil eliminado con éxito.');
            })
            .catch(function(error){
                switch (error.status) {
                    case 500:
                        logger.error(error.data.Message);
                        break;
                    case 401:
                        logger.error('La sessión ha terminado.');
                        break;
                    default:
                        logger.error('Hubo un erro al eliminar el Perfil');
                        break;
                }
                
            });   
        };

    }
})();